import React, { useState, useEffect } from 'react';
import { Grid, FormControl, TextField } from '@mui/material';
import muiInputStyles from '../../../uiComponents/MuiInput/MuiInputStyles';

const MetadataClinical = ({
  selectedWorkflow,
  metadata,
  formValues,
  errors,
  handleUploadInputChange,
  onReady,
  validateTextField,
  hasAttemptedNext,
  fieldPollingInterval,
}) => {
  const classes = muiInputStyles();
  const [localValues, setLocalValues] = useState({
    workflowName: formValues.workflowName || '',
  });
  const [localErrors, setLocalErrors] = useState({
    workflowName: '',
  });

  useEffect(() => {
    if (onReady) {
      const timer = setTimeout(() => {
        onReady();
      }, fieldPollingInterval);
      return () => clearTimeout(timer);
    }
  }, [onReady, fieldPollingInterval]);

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setLocalValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTextBlur = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim();
    const fieldMeta = metadata.find((f) => f.name === name);
    const label = fieldMeta ? fieldMeta.label : name;
    // Suppress the "required" message on blur until the user has attempted to
    // proceed at least once. Non-empty values are still validated on blur.
    const error = (trimmedValue.length === 0 && !hasAttemptedNext)
      ? ''
      : validateTextField(name, trimmedValue, label, selectedWorkflow);

    setLocalErrors((prev) => ({
      ...prev,
      [name]: error,
    }));

    setLocalValues((prev) => ({
      ...prev,
      [name]: trimmedValue,
    }));

    handleUploadInputChange({ target: { name, value: trimmedValue } });
  };

  const renderField = ({ key, label, name, required }) => {
    return (
      <div key={key}>
        <Grid container spacing={3} className="dashGridContainer">
          <Grid item xs={3}></Grid>
          <Grid item xs={6} sx={{ p: 1.5 }}>
            <FormControl fullWidth>
              <TextField
                size="small"
                id={name}
                className={classes.muiInputs}
                value={localValues[name] || ''}
                onChange={handleTextChange}
                onBlur={handleTextBlur}
                variant="outlined"
                label={label}
                name={name}
                required={required}
                error={!!(localErrors[name] || errors[name])}
                helperText={localErrors[name] || errors[name]}
                FormHelperTextProps={{
                  style: { color: '#DA190B' },
                }}
              />
            </FormControl>
          </Grid>
        </Grid>
      </div>
    );
  };

  return (
    <div className="Metadata">
      <form onSubmit={(e) => e.preventDefault()}>{metadata.map(renderField)}</form>
    </div>
  );
};

export default MetadataClinical;
